module.exports = __webpack_public_path__ + "img/2acaa6e.jpg";